import React, { useState } from 'react';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';

const sections = [
  {
    id: 'introduction',
    title: '1. Introduction',
    icon: 'ri-information-line',
    content: `AI Consulting & Automation Inc. ("Company," "we," "us," or "our") is committed to protecting your personal information and your right to privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website businessdevelopmentauthority.net, including any other media form, media channel, mobile website, or mobile application related or connected thereto (collectively, the "Site").

Please read this Privacy Policy carefully. If you disagree with its terms, please discontinue use of our Site immediately. This policy was last updated on March 25, 2026, and we reserve the right to make changes to it at any time and for any reason. We will alert you about any changes by updating the "Last updated" date on this policy.

We are headquartered at 725 E Road 2 N Unit 1494, Chino Valley, AZ 86323, United States. By continuing to use our Site, you acknowledge that you have read, understood, and agreed to be bound by this Privacy Policy.`
  },
  {
    id: 'information-we-collect',
    title: '2. Information We Collect',
    icon: 'ri-database-2-line',
    content: `We may collect information about you in a variety of ways. The information we may collect on the Site includes:

**Personal Data:** Personally identifiable information, such as your name, email address, telephone number, and mailing address, that you voluntarily give to us when you fill out a contact form, subscribe to our newsletter, request a consultation, or otherwise communicate with us.

**Derivative Data:** Information our servers automatically collect when you access the Site, such as your IP address, your browser type, your operating system, your access times, and the pages you have viewed directly before and after accessing the Site.

**Device Data:** Information about your device, including your device ID, model and manufacturer, and information about the location of your device if you access the Site from a mobile device.

**Financial Data:** If you engage our services, we may collect financial information, such as data related to your payment method. We store only very limited, if any, financial information that we collect. Otherwise, all financial information is stored by our payment processors.`
  },
  {
    id: 'how-we-use',
    title: '3. How We Use Your Information',
    icon: 'ri-settings-3-line',
    content: `Having accurate information about you permits us to provide you with a smooth, efficient, and customized experience. Specifically, we may use information collected about you via the Site to:

• Create and manage your account and consultation requests
• Email you regarding your inquiries, proposals, or service agreements
• Send you newsletters, blog updates, and marketing communications (with your consent)
• Process payments and refunds related to our AI consulting services
• Monitor and analyze usage and trends to improve your experience with the Site
• Notify you of updates to our Site and services
• Offer new products, services, and recommendations that may be of interest to you
• Perform other business activities as needed to run our consulting practice
• Prevent fraudulent transactions, monitor against theft, and protect against criminal activity
• Respond to product and customer service requests
• Comply with our legal and regulatory obligations`
  },
  {
    id: 'disclosure',
    title: '4. Disclosure of Your Information',
    icon: 'ri-share-line',
    content: `We may share information we have collected about you in certain situations. Your information may be disclosed as follows:

**By Law or to Protect Rights:** If we believe the release of information about you is necessary to respond to legal process, to investigate or remedy potential violations of our policies, or to protect the rights, property, and safety of others, we may share your information as permitted or required by any applicable law, rule, or regulation.

**Business Transfers:** We may share or transfer your information in connection with, or during negotiations of, any merger, sale of company assets, financing, or acquisition of all or a portion of our business to another company.

**Third-Party Service Providers:** We may share your information with third parties that perform services for us or on our behalf, including data analysis, email delivery, hosting services, customer service, and marketing assistance.

**Marketing Communications:** With your consent, or with an opportunity for you to withdraw consent, we may share your information with third parties for marketing purposes.

We do not sell, trade, or otherwise transfer your personally identifiable information to outside parties without your consent, except as described above.`
  },
  {
    id: 'cookies',
    title: '5. Cookies & Tracking Technologies',
    icon: 'ri-cookie-line',
    content: `We may use cookies, web beacons, tracking pixels, and other tracking technologies on the Site to help customize the Site and improve your experience. When you access the Site, your personal information is not collected through the use of tracking technology. Most browsers are set to accept cookies by default. You can remove or reject cookies, but be aware that such action could affect the availability and functionality of the Site.

**Types of Cookies We Use:**
• **Strictly Necessary Cookies:** These are essential for the operation of our website and cannot be switched off.
• **Performance Cookies:** These allow us to recognize and count the number of visitors and to see how visitors move around our website.
• **Functionality Cookies:** These enable us to personalize content and remember your preferences.
• **Targeting Cookies:** These may be set through our site by our advertising partners to build a profile of your interests.

You may opt out of interest-based advertising through the Digital Advertising Alliance or Network Advertising Initiative opt-out pages. Note that even if you opt out, you may still receive non-targeted ads from us.`
  },
  {
    id: 'third-party',
    title: '6. Third-Party Websites',
    icon: 'ri-external-link-line',
    content: `The Site may contain links to third-party websites and applications of interest, including advertisements and external services, that are not affiliated with us. Once you have used these links to leave the Site, any information you provide to these third parties is not covered by this Privacy Policy, and we cannot guarantee the safety and privacy of your information.

Before visiting and providing any information to any third-party websites, you should inform yourself of the privacy policies and practices of the third party responsible for that website, and should take those steps necessary to, in your discretion, protect the privacy of your information.

**Notable Third-Party Integrations:**
• Amazon.com and Amazon Author Central
• Barnes & Noble
• Google Analytics for website performance tracking
• Social media platforms (Facebook, Instagram, LinkedIn, YouTube, TikTok)

We are not responsible for the content or privacy practices on any third-party site. We encourage our users to be aware when they leave our site and to read the privacy statements of any other site that collects personally identifiable information.`
  },
  {
    id: 'data-security',
    title: '7. Data Security',
    icon: 'ri-shield-check-line',
    content: `We use administrative, technical, and physical security measures to help protect your personal information. While we have taken reasonable steps to secure the personal information you provide to us, please be aware that despite our efforts, no security measures are perfect or impenetrable, and no method of data transmission can be guaranteed against any interception or other type of misuse.

**Our Security Measures Include:**
• SSL/TLS encryption for all data transmission
• Secure server infrastructure with regular security audits
• Limited employee access to personal data on a need-to-know basis
• Regular security assessments and vulnerability testing
• Incident response plans for potential data breaches

Any information disclosed online is vulnerable to interception and misuse by unauthorized parties. Therefore, we cannot guarantee complete security if you provide personal information. If a data breach occurs that affects your rights and freedoms, we will notify you and any applicable regulator of a breach where we are legally required to do so.`
  },
  {
    id: 'your-rights',
    title: '8. Your Privacy Rights',
    icon: 'ri-user-settings-line',
    content: `Depending on your location, you may have certain rights regarding your personal information. These may include:

**Right to Access:** You may request a copy of the personal information we hold about you.

**Right to Rectification:** You have the right to request that we correct any information you believe is inaccurate or incomplete.

**Right to Erasure:** You have the right to request that we erase your personal data, under certain conditions.

**Right to Restrict Processing:** You have the right to request that we restrict the processing of your personal data, under certain conditions.

**Right to Object:** You have the right to object to our processing of your personal data, under certain conditions.

**Right to Data Portability:** You have the right to request that we transfer the data we have collected to another organization, or directly to you, under certain conditions.

**California Residents (CCPA):** If you are a California resident, you have additional rights including the right to know what personal information is being collected, the right to know whether your personal information is sold or disclosed and to whom, and the right to opt-out of the sale of your personal information.

To exercise any of these rights, please contact us at the information provided in the "Contact Us" section below.`
  },
  {
    id: 'children',
    title: '9. Children\'s Privacy',
    icon: 'ri-parent-line',
    content: `We do not knowingly solicit information from or market to children under the age of 13. If you become aware of any data we have collected from children under age 13, please contact us immediately using the contact information provided below.

The Site is not intended for use by children under the age of 13. We do not knowingly collect personally identifiable information from children under 13. If we learn we have collected or received personal information from a child under 13 without verification of parental consent, we will delete that information.

If you believe we might have any information from or about a child under 13, please contact us at the address listed at the end of this Privacy Policy. Parents or guardians who have given consent for the collection of their child\'s personal information may revoke that consent at any time by contacting us directly.`
  },
  {
    id: 'contact',
    title: '10. Contact Us',
    icon: 'ri-mail-line',
    content: `If you have questions or comments about this Privacy Policy, please contact us at:

**AI Consulting & Automation Inc.**
725 E Road 2 N Unit 1494
Chino Valley, AZ 86323
United States

Website: businessdevelopmentauthority.net

You may also reach us through the contact form on our website or by scheduling a consultation through our calendar page. We will respond to your privacy-related inquiries within 30 days.

For ongoing updates regarding our privacy practices, we encourage you to revisit this Privacy Policy periodically. We reserve the right to make changes to this policy at any time and for any reason. Your continued use of our Site following the posting of changes to this policy will be deemed your acceptance of those changes.`
  }
];

const PrivacyPolicyPage: React.FC = () => {
  const [activeSection, setActiveSection] = useState<string>('introduction');

  const scrollToSection = (id: string) => {
    setActiveSection(id);
    const el = document.getElementById(id);
    if (el) {
      const offset = 100;
      const top = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero */}
      <section
        className="relative min-h-[380px] flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.65), rgba(0,0,0,0.65)), url('https://public.readdy.ai/ai/img_res/8435f7109e84e8ceed2fcfc589baaabd.jpg')`
        }}
      >
        <div className="max-w-4xl mx-auto px-6 text-center text-white w-full">
          <div className="w-16 h-16 flex items-center justify-center bg-white/10 rounded-full mx-auto mb-6 border border-white/20">
            <i className="ri-shield-keyhole-line text-3xl text-white"></i>
          </div>
          <h1 className="text-5xl font-bold mb-4">Privacy Policy</h1>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto">
            Your privacy matters to us. Learn how AI Consulting & Automation Inc. collects, uses, and protects your personal information.
          </p>
          <p className="text-sm text-gray-400 mt-4">Last Updated: March 25, 2026</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex gap-10">

            {/* Sticky Sidebar */}
            <aside className="hidden lg:block w-72 flex-shrink-0">
              <div className="sticky top-24 bg-white rounded-lg border border-gray-200 p-5">
                <h3 className="text-xs font-semibold uppercase tracking-widest text-gray-400 mb-4">Table of Contents</h3>
                <nav className="space-y-1">
                  {sections.map((sec) => (
                    <button
                      key={sec.id}
                      onClick={() => scrollToSection(sec.id)}
                      className={`w-full text-left px-3 py-2 rounded-md text-sm transition-colors cursor-pointer flex items-center gap-2 whitespace-nowrap ${
                        activeSection === sec.id
                          ? 'bg-gray-900 text-white font-medium'
                          : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                      }`}
                    >
                      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                        <i className={`${sec.icon} text-sm`}></i>
                      </div>
                      <span className="text-xs leading-tight">{sec.title}</span>
                    </button>
                  ))}
                </nav>
              </div>
            </aside>

            {/* Main Content */}
            <div className="flex-1 min-w-0">
              <div className="bg-white rounded-lg border border-gray-200 p-8 md:p-10">
                <p className="text-gray-600 text-sm leading-relaxed mb-10 pb-8 border-b border-gray-100">
                  This Privacy Policy describes how AI Consulting & Automation Inc. handles your personal information across our website and services. Please read it thoroughly to understand our practices.
                </p>

                <div className="space-y-12">
                  {sections.map((sec) => (
                    <div key={sec.id} id={sec.id} className="scroll-mt-28">
                      <div className="flex items-center gap-3 mb-5">
                        <div className="w-10 h-10 flex items-center justify-center bg-gray-900 rounded-lg flex-shrink-0">
                          <i className={`${sec.icon} text-lg text-white`}></i>
                        </div>
                        <h2 className="text-xl font-bold text-gray-900">{sec.title}</h2>
                      </div>
                      <div className="text-gray-700 text-sm leading-relaxed space-y-3 pl-13">
                        {sec.content.split('\n\n').map((para, i) => {
                          if (para.startsWith('**') && para.includes(':**')) {
                            const [boldPart, ...rest] = para.split(':**');
                            const label = boldPart.replace('**', '');
                            return (
                              <p key={i}>
                                <strong className="text-gray-900">{label}:</strong>
                                {rest.join(':**')}
                              </p>
                            );
                          }
                          if (para.startsWith('•')) {
                            const items = para.split('\n').filter(l => l.trim());
                            return (
                              <ul key={i} className="list-none space-y-1">
                                {items.map((item, j) => (
                                  <li key={j} className="flex items-start gap-2">
                                    <span className="text-gray-400 mt-0.5">•</span>
                                    <span>{item.replace(/^•\s*/, '')}</span>
                                  </li>
                                ))}
                              </ul>
                            );
                          }
                          return <p key={i}>{para}</p>;
                        })}
                      </div>
                      <div className="mt-8 border-b border-gray-100"></div>
                    </div>
                  ))}
                </div>

                {/* Bottom CTA */}
                <div className="mt-12 bg-gray-50 rounded-lg p-6 text-center">
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Have Questions About Your Privacy?</h3>
                  <p className="text-gray-600 text-sm mb-5">Our team is happy to address any concerns about how we handle your data.</p>
                  <a
                    href="/calendar"
                    className="whitespace-nowrap inline-flex items-center gap-2 bg-gray-900 text-white px-6 py-3 rounded-md text-sm font-medium hover:bg-gray-700 transition-colors cursor-pointer"
                  >
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-calendar-line text-sm"></i>
                    </div>
                    Schedule a Consultation
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;
